export const FETCH_SELLS = 'sell/FETCH_SELLS'
export const FETCH_SELLS_SUCCESS = 'sell/FETCH_SELLS_SUCCESS'
export const FETCH_SELLS_FAILURE = 'sell/FETCH_SELLS_FAILURE'
export const RESET_SELLS = 'sell/RESET_SELLS'

export const FETCH_SELL = 'sell/FETCH_SELL'
export const FETCH_SELL_SUCCESS = 'sell/FETCH_SELL_SUCCESS'
export const FETCH_SELL_FAILURE = 'sell/FETCH_SELL_FAILURE'
export const RESET_SELL = 'sell/RESET_SELL'

export const FETCH_IGV = 'sell/FETCH_IGV'
export const FETCH_IGV_SUCCESS = 'sell/FETCH_IGV_SUCCESS'
export const FETCH_IGV_FAILURE = 'sell/FETCH_IGV_FAILURE'
export const RESET_IGV = 'sell/RESET_IGV'

export const FETCH_ITEMS_LIST = 'sell/FETCH_ITEMS_LIST'
export const FETCH_ITEMS_LIST_SUCCESS = 'sell/FETCH_ITEMS_LIST_SUCCESS'
export const FETCH_ITEMS_LIST_FAILURE = 'sell/FETCH_ITEMS_LIST_FAILURE'
export const RESET_ITEMS_LIST = 'sell/RESET_ITEMS_LIST'

export const ADD_SELL = 'sell/ADD_SELL'
export const ADD_SELL_SUCCESS = 'sell/ADD_SELL_SUCCESS'
export const ADD_SELL_FAILURE = 'sell/ADD_SELL_FAILURE'
export const RESET_ADD_SELL = 'sell/RESET_ADD_SELL'


// WEBPACK FOOTER //
// ./src/store/sell/actionTypes.js